import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "../i18n";
import { PageHero, PillButton, Reveal } from "../components/Shared";

const Services = () => {
  const { t, data } = useLanguage();

  return (
    <div data-testid="services-page">
      <PageHero
        title={t.servicesPage.title}
        subtitle={t.servicesPage.subtitle}
        image="https://images.unsplash.com/photo-1462396240927-52058a6a84ec?w=1920&q=80"
      />

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 space-y-24">
          {data.services.map((s, i) => (
            <Reveal key={s.id}>
              <div
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  i % 2 === 1 ? "lg:[direction:rtl]" : ""
                }`}
                data-testid={`service-detail-${s.id}`}
              >
                <div className="lg:[direction:ltr] relative group overflow-hidden rounded-lg shadow-lg">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-72 md:h-96 object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#141d43]/60 to-transparent" />
                  <div className="absolute bottom-6 left-6">
                    <span className="bg-white text-[#1b2653] px-5 py-2 rounded-full text-sm font-semibold tracking-wide shadow-md">
                      {s.title}
                    </span>
                  </div>
                </div>
                <div className="lg:[direction:ltr]">
                  <span className="text-[#2f6fd8] text-xs font-semibold uppercase tracking-[0.25em]">
                    {t.servicesPage.serviceLabel} {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="text-3xl md:text-4xl font-semibold text-[#1b2653] mt-3 mb-5">{s.title}</h2>
                  <p className="text-slate-600 leading-loose font-light mb-8">{s.short}</p>
                  <ul className="space-y-3.5">
                    {s.details.map((d) => (
                      <li key={d} className="flex items-start gap-3">
                        <CheckCircle2 size={19} className="text-[#2547a8] mt-0.5 shrink-0" />
                        <span className="text-slate-700 text-[15px]">{d}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#1b2653] py-20">
        <div className="max-w-4xl mx-auto px-5 text-center">
          <Reveal>
            <h2 className="text-2xl md:text-3xl font-semibold text-white leading-snug">{t.servicesPage.ctaTitle}</h2>
            <p className="text-white/70 font-light mt-4">{t.servicesPage.ctaText}</p>
            <div className="mt-9">
              <PillButton to="/rendez-vous">{t.requestRdv}</PillButton>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Services;
